import React,{useContext,useEffect} from 'react';
import {UserContext} from './App';

function Home() {

  const {state, dispatch} = useContext(UserContext);

  dispatch({type:'USER',payload:false})

  useEffect(()=>{
    localStorage.clear();
  },[])

 function ComponentDidMount() 
  {
    const { history } = this.props;
     window.addEventListener("popstate", () => {
     history.go(1);
    });
   }

  return (

      <div className="container flex"  style={{'height':'70%', 
        'width':'35%',
        'margin': '6%',
        'marginLeft' : '30%',
        'marginTop':'12%'
      }}> 
        <div style={{'display':'block','marginTop':'40px', 'marginLeft':'140px' }}>
          <img alt="" src={require('./asset/images/logo.png')} />
          <p style={{'display':'block', 'fontSize':'20px', 'marginLeft':'10px', 
          'marginTop':'40px','marginBottom':'40px'        
          }}>Admin Dashboard</p>
          
        </div>
      </div>
  )
}

export default Home
